const $faqHeader = $(".index-faq__faq-header");

if ($faqHeader.length > 0) {
    $faqHeader.on("click", function () {
        if ($(this).parent().hasClass("open")) {
            $(".index-faq__faq-item").removeClass("open");

            $(".index-faq__faq-answer").slideUp(200);
        } else {
            $(".index-faq__faq-item").removeClass("open");
            $(this).parent().addClass("open");

            $(".index-faq__faq-answer").slideUp(200);
            $(this).siblings(".index-faq__faq-answer").slideDown(200);
        }
    });
}